import { create } from 'zustand';

/**
 * Phase 1b cutover (2026-05-13): the legacy `parts` and `inventorylog`
 * tables were dropped. This store used to fetch `/api/parts` and cache the
 * legacy ffpartnum-shaped catalog. That endpoint no longer exists.
 *
 * The store is kept as a no-op shim so existing call sites (App.js login
 * refresh loop, Login/RegisterUser refreshParts on login, EditDrone +
 * AddBatch + ShopHome parts-list filters)
 * continue to import + invoke their store methods without any 404 noise.
 * They all read an empty `parts` array, which renders as empty dropdowns
 * rather than a thrown error.
 *
 * The five legacy workflow callers (drone-edit, batch-add, parts-popup,
 * config-add, shop-home) are tagged as Phase 1c+ rewrites — they each
 * need a redesigned data shape against `parts_catalog` (different field
 * names, no per-row stock, no `parttype` classifier). Not blocking the
 * Phase 1b deploy.
 *
 * Dashboard widgets that need parts data now use
 * `src/Dashboard/usePartsStatus.ts` against `/api/dashboard/parts-status`.
 */
const usePartsStore = create((set, get) => ({
  parts: [],
  loading: false,
  error: null,

  // All actions are no-ops post-cutover. Preserved so legacy call sites
  // keep their existing import shapes; deleting the store outright would
  // require touching every consumer in this same change.
  fetchParts: async () => {},
  refreshParts: async () => {},
  updatePart: () => {},
  addPart: () => {},
  removePart: () => {},
  clearParts: () => {},
}));

export default usePartsStore;
